import Table from './Table.vue'
import Icon from './Icon'
import IconPicker from './IconPicker'
import Player from './Player'
import Tooltip from './Tooltip'
// import objectAddOrEdit from './objectAddOrEdit'
import PacketSelector from './PacketSelector'
import formMix from '@/views/customObject/formMix.vue'
import Page from './page'
import PageTitle from './pageTitle'
import Audio from './Audio'
import ImgPreview from './ImgPreview'
import UploadField from './uploadField'
import FileField from './fileFieldLayout'
import Questionnaire from './questionnaire/questionnaire.vue'
import Treeselect from '@riophae/vue-treeselect'
// import KnowledgeInfo from './knowledge/knowledgeInfo'
import objectEditDrawer from './objectEditDrawer'
import FormField from './questionnaire/index.vue'
import objectAddOrEdit from './questionnaire/index.vue' //全量替换公共表单组件
import SuperTree from './super-tree/index.vue' 
import TreeItem from './super-tree/tree-configure/TreeItem.vue'
import InfinitySelect from './infinity-select/index.vue' 
// import NewTable from './table/table'
//基础组件
const baseComponents = {
  Table,
  Icon,
  Player,
  Tooltip,
  IconPicker,
  PageTitle,
  Audio,
  ImgPreview,
  UploadField,
  FileField,
  Questionnaire
  // KnowledgeInfo
  // NewTable
}
//保留原组件名组件
const businessComponents = {
  objectAddOrEdit,
  PacketSelector,
  formMix,
  Page,
  Treeselect,
  FormField,
  SuperTree,
  TreeItem,
  InfinitySelect
}
//自定义使用默认注册到页面里通过eventBus事件调用的组件
const dynamicComponent = {
  objectEditDrawer
}

export default Vue => {
  for (let name in baseComponents) {
    Vue.component(`C${name}`, baseComponents[name])
  }
  for (let name in businessComponents) {
    Vue.component(name, businessComponents[name])
  }
  for (let name in dynamicComponent) {
    Vue.prototype.$dynamicComponent.add(dynamicComponent[name])
  }
}
